import { render, staticRenderFns } from "./ProjectsOverviewField.vue?vue&type=template&id=ae219ee2&scoped=true"
import script from "./ProjectsOverviewField.vue?vue&type=script&lang=ts"
export * from "./ProjectsOverviewField.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsOverviewField.vue?vue&type=style&index=0&id=ae219ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae219ee2",
  null
  
)

export default component.exports